import React from 'react';

const RangeInput = ({ label, val, setVal, min, max, step }) => (
  <div className="space-y-3">
    <div className="flex justify-between items-center text-xs font-bold uppercase text-slate-500">
      <label>{label}</label>
      <span className="text-[#041627]">{val.toLocaleString()}</span>
    </div>
    <input
      type="range"
      min={min} max={max} step={step} value={val}
      onChange={(e) => setVal(Number(e.target.value))}
      className="w-full h-1.5 bg-slate-100 rounded-lg appearance-none cursor-pointer accent-[#041627]"
    />
  </div>
);

export default RangeInput;